import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminGenres() {
    return useQuery({
        queryKey: adminKeys.genres(),
        queryFn: adminApi.getGenres,
        staleTime: Infinity,
    });
}
